module.exports = __webpack_public_path__ + "static/img/SUP_PHOTO_PRM.3f00a67.jpg";